import React, { useState, useEffect } from 'react';
import Scrollfunctions from '../Components/Scrollfunctions';
import { motion } from 'framer-motion';

const FirstSlide = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 368);
const vizauraLogo = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/logo/vizaura_logo.png"
const heroBackground = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/bg-firstslide-PC.jpg"
const mobileBackground = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/bg-firstslide-PHONE2.png"
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 368);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const backgroundImage = isMobile ? mobileBackground : heroBackground;

  return (
    <div className='relative' id='home'>
      <div
        className='h-screen w-full flex items-center justify-center text-white transition-all duration-500 pb-10'
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          maxWidth: '100vw',
        }}
      >
        <div className="absolute inset-0 bg-black/20"></div> {/* Optional overlay */}

        <motion.div
          className="z-10 max-w-4xl mx-auto text-center px-4  mt-10
    transform md:translate-y-0 -translate-y-10" // Move up more on mobile
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="text-2xl md:text-4xl font-serif  mb-4 ">
            Welcome to
          </h1>

          {isMobile ? (
            <h1 className="text-3xl font-serif mb-4 md:mb-6">VIZAURA</h1>
          ) : (
            <img
              src={vizauraLogo}
              alt="VIZAURA Logo"
              className="mx-auto w-60 md:w-85 mb-4 md:mb-6"
            />
          )}


          <h2 className="text-xl md:text-2xl font-serif leading-relaxed text-gray-100 pt-8">
            VIZAURA offers premium Wallpapers, Art Prints, Hand Paintings, and Custom Graphics tailored to your space.
            Blending creativity with craftsmanship, we turn walls into canvases and spaces into statements.
            <br /><br />
            Whether you're decorating a home, office, or corporate space, we've got you covered. From hospitals and gyms to cafes and more, VIZAURA brings character to every kind of space.
          </h2>
        </motion.div>


      </div>

      <Scrollfunctions />
    </div>
  );
};

export default FirstSlide;
